export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq60_buy.736a1185.mp3";